<template>
  <div class="other-school-section">
    <div class="form-group">
      <h3>Postcode</h3>
      <input id="school-zipcode" type="text" class="form-control" @change="onZipcodeChanged" v-model="zipcode"
             placeholder="vb.: 9031" autocomplete="off">
    </div>

    <div class="loader-wrapper text-center my-3" v-if="fetchingSchools">
      <div class="spinner-border" role="status">
        <span class="sr-only">Laden...</span>
      </div>
    </div>

    <div v-show="!fetchingSchools && showOtherSchoolDropdown">
      <h3>School selecteren</h3>

      <!--      <IconDropdownButton id="other-school-select-dropdown-button" iconName="" :buttonText=schoolSelectButtonTitle-->
      <!--                          @click="otherSchoolSelectDropdownClicked"></IconDropdownButton>-->

      <ul class="school-list">
        <li :key="school.id" v-for="school in schools" class="school-list__item" @click="selectSchool(school)"
            :class="{ 'active': school.id === selectedSchool?.id }">
          {{ school.name }} - {{ school.address }} {{ school.postalCode }}
        </li>
      </ul>

      <Pagination :use-event-for-load-page="true" :item-count="listInfo.totalElements"
                  :items-per-page="schoolsPerPage" @page-changed="onSchoolPageChanged"></Pagination>
    </div>
  </div>
</template>

<script>
import { SchoolApi } from "sandpiper_api";
import log from "@/utils/logger";
import Pagination from "@/components/UI/Pagination";

export default {
  name: "ZipSchoolForm",
  components: { Pagination },
  inject: [ "doApiRequest" ],
  props: {
    closeOnSelected: Boolean,
    selectedSchool: {
      type: Object,
      default: null
    }
  },
  data()
  {
    return {
      otherSchoolDropdownOpen: false,
      zipcode: null,

      fetchingSchools: false,
      schools: [],

      page: 1,
      schoolsPerPage: 20,
      listInfo: {}
    }
  },
  computed: {
    showOtherSchoolDropdown()
    {
      return this.schools.length > 0;
    },
    schoolSelectButtonTitle()
    {
      if (this.selectedSchool !== null)
      {
        return this.selectedSchool.name;
      }
      else if (this.schools <= 0)
      {
        return "Geen scholen gevonden voor deze postcode"
      }
      else
      {
        return "School selecteren";
      }
    },
  },
  methods: {
    onZipcodeChanged()
    {
      if (/^\d+$/.test(this.zipcode) && this.zipcode.length === 4)
      {
        this.$emit("zipcodeUpdated", this.zipcode);

        this.fetchSchoolsForZipcode(this.zipcode);
      }
    },
    // otherSchoolSelectDropdownClicked()
    // {
    //   this.toggleOtherSchoolDropdown();
    // },
    toggleOtherSchoolDropdown()
    {
      this.otherSchoolDropdownOpen = !this.otherSchoolDropdownOpen;
    },
    selectSchool(school)
    {
      this.$emit("selectSchool", school);
      this.otherSchoolDropdownOpen = false;
    },

    onSchoolPageChanged(page)
    {
      this.page = page;
      this.fetchSchoolsForZipcode(this.zipcode);
    },

    async fetchSchoolsForZipcode(zipcode)
    {
      try
      {
        this.fetchingSchools = true;
        this.schools = [];
        const response = await this.doApiRequest(() => new SchoolApi().getSchools({
          postalCode: zipcode,
          page: this.page - 1,
          count: this.schoolsPerPage
        }));

        this.schools = response.schools;
        this.listInfo = {
          currentPage: response.currentPage,
          numberOfElements: response.numberOfElements,
          totalPages: response.totalPages,
          totalElements: response.totalElements
        };
      }
      catch (e)
      {
        log.error("Failed to fetch schools - %o", e);
      }
      finally
      {
        // setTimeout(() => this.fetchingSchools = false, 3000); // Throttle fetch speed so that we can see spinner 
        this.fetchingSchools = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card
{
  background-color: white;
  border-radius: 5px;
  box-shadow: $default-shadow;
  padding: 25px;
  margin-top: 25px;

  .title
  {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 0.3rem;
  }

  .subtitle
  {
    font-size: 1rem;
    font-style: italic;
    margin-bottom: 0.3rem;
  }
}

.save-changes-button
{
  margin-bottom: 25px;
}

.cancel-button
{
  align-self: center;
}

.edit-buddy-form
{
  margin-top: 25px;
  display: flex;
  flex-direction: column;
}

.school-list
{
  display: block;
  position: relative;
  width: 100%;
  padding: 0;
  margin: 0 0 5px 0;
  background-color: $soft-highlight;

  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;

  > .school-list__item
  {
    display: block;
    width: 100%;
    padding: 0.25rem 1.5rem;
    clear: both;
    font-weight: 400;
    color: #212529;
    text-align: inherit;
    white-space: nowrap;
    background-color: transparent;
    border: 0;

    &:hover,
    &:focus
    {
      color: #16181b;
      text-decoration: none;
      background-color: #e9ecef;
    }

    &.active,
    &:active
    {
      color: #fff;
      text-decoration: none;
      background-color: $primary-blue;
    }
  }
}
</style>